import type { LinkResult, LinkView } from "../main/LinkController";
import { linkResultText, linkText } from "../strings";

function statusText(v: LinkView): string {
  switch (v.kind) {
    case "idle":
      return "";
    case "connecting":
      return linkText.connecting;
    case "verifying":
    case "binding":
    case "handshake":
    case "armed":
      return linkText.waitingSave;
    case "running":
      return v.inLinkRoom ? linkText.faceGameBoy : linkText.walkToEnd;
    case "ended":
    case "error":
      return linkText.walkToEnd;
  }
}

/** Link status under the game screen. Progress only; no join code. */
export function LinkStatusBar(props: { view: LinkView; result: LinkResult | null; onCancel: () => void; onDismiss: () => void }) {
  const { view, result } = props;
  if (view.kind === "idle" && !result) return null;
  const text = statusText(view);
  const canCancel = view.kind !== "idle" && view.kind !== "ended" && view.kind !== "error";
  const finished = view.kind === "ended" || view.kind === "error" || view.kind === "idle";

  return (
    <div className="link-status" role="status" aria-live="polite">
      {text && <span className="status">{text}</span>}
      {result && <span className="status ok">{linkResultText(result)}</span>}
      {canCancel && <button onClick={props.onCancel}>{view.kind === "running" ? linkText.leave : linkText.cancel}</button>}
      {finished && !(view.kind === "ended" && view.needsReload) && <button onClick={props.onDismiss}>{linkText.dismiss}</button>}
      {view.kind === "ended" && view.needsReload && <button onClick={() => window.location.reload()}>Reload</button>}
    </div>
  );
}
